import React from 'react';
import './UKUniversities.css'; // Reuse the same CSS for consistent styling

const universities = {
  A: [
    "Australian National University (not listed but notable)"
  ],
  C: [
    "Charles Darwin University",
    "Charles Sturt University",
    "Curtin University",
  ],
  D: [
    "Deakin University",
  ],
  E: [
    "Edith Cowan University",
  ],
  F: [
    "Federation University Australia",
    "Flinders University",
  ],
  G: [
    "Griffith University",
  ],
  J: [
    "James Cook University",
  ],
  L: [
    "La Trobe University",
  ],
  M: [
    "Macquarie University",
    "Monash University",
    "Murdoch University",
  ],
  Q: [
    "Queensland University of Technology",
  ],
  R: [
    "RMIT University",
  ],
  S: [
    "Southern Cross University",
    "Swinburne University of Technology",
  ],
  T: [
    "Torrens University (private)",
  ],
  U: [
    "University of Adelaide",
    "University of Canberra",
    "University of Divinity (private)",
    "University of Melbourne",
    "University of New England",
    "University of New South Wales",
    "University of Newcastle",
    "University of Notre Dame Australia (private)",
    "University of Queensland",
    "University of South Australia",
    "University of Southern Queensland",
    "University of Sydney",
    "University of Tasmania",
    "University of Technology Sydney",
    "University of the Sunshine Coast",
    "University of Western Australia",
    "University of Wollongong",
  ],
  V: [
    "Victoria University",
  ],
  W: [
    "Western Sydney University",
  ],
  I: [
    "Carnegie Mellon University – Adelaide campus (international private)",
    "University College London – Australia (international private)",
  ]
};

const AustraliaUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Australia Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AustraliaUniversities;
